import { SortingType } from '@/study-search/enums';
import { SortingOptionDefinition } from '../../../../models/definition/SortingOptionDefinition';
import store from '@/study-search/store';

export default class SortContainer {
	public readonly sortingOptions = [
		new SortingOptionDefinition(0, 'Our picks', 'lnr-archery', SortingType.RELEVANCE),
		new SortingOptionDefinition(1, 'Lowest tuition Fee', 'lnr-bag-coins', SortingType.TUITION_FEE_ASC),
	];

	public isSelected(optionIndex: number): boolean {
		return this.getSelectedOptionIndex() === optionIndex;
	}

	public async select(optionIndex: number): Promise<void> {
		await store.actions.processSortingClick(this.sortingOptions[optionIndex].type);
	}

	private getSelectedOptionIndex(): number {
		const activeSortingOption = this.sortingOptions.filter((sortingOption) => sortingOption.type === store.getters.getSorting());
		return activeSortingOption[0].id;
	}
}
